import { cn } from "./lib/cn";

interface AvatarBubbleProps {
  name: string | null;
  className?: string;
}

/**
 * The single initial-circle primitive for the whole slideshow surface — one
 * person always renders the same way (facepile avatar, audience-sheet row,
 * recent-contributor pile). Soft warm fill so overlapping avatars read as
 * gentle depth. Size / ring / border come from `className`.
 */
export function AvatarBubble({ name, className }: AvatarBubbleProps) {
  return (
    <span
      className={cn(
        "rounded-full bg-primary/80 text-white flex items-center justify-center font-bold select-none",
        className,
      )}
    >
      {name?.[0]?.toUpperCase() ?? "?"}
    </span>
  );
}
